import React from 'react'
import Link from 'next/link'
import Image from 'next/image';
import SectionHeading from '../../Common/SectionHeading';

export default function ProcessSection() {
  return (
    <>
        <section className="w-11/12 xl:max-w-screen max-w-screen-2xl flex flex-col justify-center mx-auto lg:my-10 my-6">
            <SectionHeading 
                title="Conference Coverage Process"
                
            />
            <div className='grid grid-cols-12 gap-4'>
                <div className='md:col-span-4 col-span-12'>
                    <div className="md:hover:shadow-md md:shadow-none shadow-md rounded p-6">
                        <div className="">
                            <div className="flex items-center mb-2">
                                <span className="text-4xl font-semibold relative pr-70 text-blue-500 after:content-[' '] after:absolute after:w-10 after:h-[1px] after:top-5 after:left-[60px] after:bg-gray-300">01</span>
                                <h3 className="text-lg font-semibold pl-20">Pre-congress</h3>
                            </div>
                            <p className='m-0 font-medium text-base'>Congress Preparation</p>
                            <ul className="my-2">
                                <li className="flex py-2">
                                    <span className="bg-[#1DA1F2] mt-1 dark:bg-gray-600 flex h-[1.1rem] items-center justify-center mr-2 rounded-full text-xs w-[1.1rem]">
                                        <i className="fa fa-angle-right text-white"></i>
                                    </span>
                                    Prepare Pharma Conference Planner
                                </li>
                                <li className="flex py-2">
                                    <span className="bg-[#1DA1F2] mt-1 dark:bg-gray-600 flex h-[1.1rem] items-center justify-center mr-2 rounded-full text-xs w-[1.1rem]">
                                        <i className="fa fa-angle-right text-white"></i>
                                    </span>
                                    Prioritization and Selection of Abstract
                                </li>
                                <li className="flex py-2">
                                    <span className="bg-[#1DA1F2] mt-1 dark:bg-gray-600 flex h-[1.1rem] items-center justify-center mr-2 rounded-full text-xs w-[1.1rem]">
                                        <i className="fa fa-angle-right text-white"></i>
                                    </span>
                                    Categorization Based on Priority
                                </li>
                                <li className="flex py-2">
                                    <span className="bg-[#1DA1F2] mt-1 dark:bg-gray-600 flex h-[1.1rem] items-center justify-center mr-2 rounded-full text-xs w-[1.1rem]">
                                        <i className="fa fa-angle-right text-white"></i>
                                    </span>
                                    Prepare and Review of KIQs and Key Data Points
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className='md:col-span-4 col-span-12'>
                    <div className="md:hover:shadow-md shadow-md rounded p-6">
                        <div className="">
                            <div className="flex items-center mb-2">
                                <span className="text-4xl font-semibold relative pr-70 text-blue-500 after:content-[' '] after:absolute after:w-10 after:h-[1px] after:top-5 after:left-[60px] after:bg-gray-300">02</span>
                                <h3 className="text-lg font-semibold pl-20">During Congress</h3>
                            </div>
                            <p className='m-0 font-medium text-base'>Data Gathering</p>
                            <ul className="my-2">
                                <li className="flex py-2">
                                    <span className="bg-[#1DA1F2] mt-1 dark:bg-gray-600 flex h-[1.1rem] items-center justify-center mr-2 rounded-full text-xs w-[1.1rem]">
                                        <i className="fa fa-angle-right text-white"></i>
                                    </span>
                                    Capturing Digital Images
                                </li>
                                <li className="flex py-2">
                                    <span className="bg-[#1DA1F2] mt-1 dark:bg-gray-600 flex h-[1.1rem] items-center justify-center mr-2 rounded-full text-xs w-[1.1rem]">
                                        <i className="fa fa-angle-right text-white"></i>
                                    </span>
                                    Covering Sessions
                                </li>
                                <li className="flex py-2">
                                    <span className="bg-[#1DA1F2] mt-1 dark:bg-gray-600 flex h-[1.1rem] items-center justify-center mr-2 rounded-full text-xs w-[1.1rem]">
                                        <i className="fa fa-angle-right text-white"></i>
                                    </span>
                                    Interviewing Key Stakeholders and KOLs
                                </li>
                                <li className="flex py-2">
                                    <span className="bg-[#1DA1F2] mt-1 dark:bg-gray-600 flex h-[1.1rem] items-center justify-center mr-2 rounded-full text-xs w-[1.1rem]">
                                        <i className="fa fa-angle-right text-white"></i>
                                    </span>
                                    Collecting Conference Materials to Understand the Product
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className='md:col-span-4 col-span-12'>
                    <div className="md:hover:shadow-md md:shadow-none shadow-md rounded p-6">
                        <div className="">
                            <div className="flex items-center mb-2">
                                <span className="text-4xl font-semibold relative pr-70 text-blue-500 after:content-[' '] after:absolute after:w-10 after:h-[1px] after:top-5 after:left-[60px] after:bg-gray-300">03</span>
                                <h3 className="text-lg font-semibold pl-20">Post-Congress</h3>
                            </div>
                            <p className='m-0 font-medium text-base'>Analysis & Reporting</p>
                            <ul className="my-2">
                                <li className="flex py-2">
                                    <span className="bg-[#1DA1F2] mt-1 dark:bg-gray-600 flex h-[1.1rem] items-center justify-center mr-2 rounded-full text-xs w-[1.1rem]">
                                        <i className="fa fa-angle-right text-white"></i>
                                    </span>
                                    Organize Information from Key Sessions/Abstracts/Posters
                                </li>
                                <li className="flex py-2">
                                    <span className="bg-[#1DA1F2] mt-1 dark:bg-gray-600 flex h-[1.1rem] items-center justify-center mr-2 rounded-full text-xs w-[1.1rem]">
                                        <i className="fa fa-angle-right text-white"></i>
                                    </span>
                                    Addressing the Key Intelligence Questions
                                </li>
                                <li className="flex py-2">
                                    <span className="bg-[#1DA1F2] mt-1 dark:bg-gray-600 flex h-[1.1rem] items-center justify-center mr-2 rounded-full text-xs w-[1.1rem]">
                                        <i className="fa fa-angle-right text-white"></i>
                                    </span>
                                    Preparing Executive Summary and Detailed Report
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}
